import { FormattedMessage } from "react-intl";
import { INotifyDate } from "../../../../../pages/AdminConsole/NotifyAdminManagement/module/constants";
import { IResponseState } from "../../../ResponseModal/module/constants";
import messages from "./messages";

export interface IAddEditModalProp {
  show: boolean;
  setShow: any;
  size?: "lg" | "sm" | "xl" | undefined;
  responseUpdateState: IResponseState;
  isEdit: boolean;
  toEdit: INotifyDate;
  onClose: any; //TODO ??
  sendUpdate: (data: any) => void;
  sendNew: (data: any) => void;
  onCloseResponse: () => void;
  allRoles: string[];
}

export const fieldsList = {
  title: <FormattedMessage {...messages.title} />,
  text: <FormattedMessage {...messages.text} />,
  roles: <FormattedMessage {...messages.roles} />,
};
